import React from "react";

const portfolioData = [
  {
    id: 1,
    title: "JoinYourTrip",
    image: "/img/portfolio-img/joinyourtrip.com.jpg",
    categories: '["creative", "travel"]',
    projectLink: "https://joinyourtrip.com",
  },
  {
    id: 2,
    title: "Yana Synapse",
    image: "/img/portfolio-img/yanasynapse.com.jpg",
    categories: '["travel"]',
    projectLink: "https://yanasynapse.com",  
  },
  {
    id: 3,
    title: "Itaiba Retreat",
    image: "/img/portfolio-img/itaiba.in.jpg",
    categories: '["travel"]',
    projectLink: "https://itaiba.in",  
  },
  {
    id: 4,
    title: "Casa Palmira",
    image: "/img/portfolio-img/casapalmira.it.jpg",
    categories: '["travel", "services"]',
    projectLink: "https://casapalmira.it",
  },
  {
    id: 5,
    title: "Fana Resort",
    image: "/img/portfolio-img/fanaresort.com.jpg",
    categories: '["travel"]',
    projectLink: "https://fanaresort.com",
  },
  {
    id: 6,
    title: "Cashmere Charmers",
    image: "/img/portfolio-img/cashmerecharmers.com.jpg",
    categories: '["ecom"]',
    projectLink: "https://cashmerecharmers.com",
  },
  {
    id: 7,
    title: "LehGo",
    image: "/img/portfolio-img/lehgo.in.jpg",
    categories: '["ecom", "travel", "services"]',
    projectLink: "https://lehgo.in",
  },
  {
    id: 8,
    title: "The Finance Guild",
    image: "/img/portfolio-img/thefinanceguild.com.jpg",
    categories: '["services"]',
    projectLink: "https://thefinanceguild.com",
  },
  {
    id: 9,
    title: "Beyond Just Work",
    image: "/img/portfolio-img/beyondjustwork.com.jpg",
    categories: '["services", "travel"]',
    projectLink: "https://beyondjustwork.com",
  },
  {
    id: 10,
    title: "Think Tank Pictures",
    image: "/img/portfolio-img/thinktankpictures.com.jpg",
    categories: '["services", "creative"]',
    projectLink: "https://thinktankpictures.com",
  },
  {
    id: 11,
    title: "Tatvam Resort",
    image: "/img/portfolio-img/tatvamresort.com.jpg",
    categories: '[ "travel"]',
    projectLink: "https://tatvamresort.com",
  },
  {
    id: 12,
    title: "Monylook",
    image: "/img/portfolio-img/monylook.ch.jpg",
    categories: '["services"]',
    projectLink: "https://monylook.ch",
  },
  {
    id: 13,
    title: "PC Beheben",
    image: "/img/portfolio-img/pcbeheben.de.jpg",
    categories: '["services"]',
    projectLink: "https://pcbeheben.de",
  },
  {
    id: 14,
    title: "Brow and Lash Boutique",
    image: "/img/portfolio-img/browandlashboutique.de.jpg",
    categories: '["services"]',
    projectLink: "https://browandlashboutique.de",
  },
  {
    id: 15,
    title: "DS Steinteppich",
    image: "/img/portfolio-img/ds-steinteppich.de.jpg",
    categories: '["services"]',
    projectLink: "https://ds-steinteppich.de",
  },
  {
    id: 16,
    title: "Treble Clef",
    image: "/img/portfolio-img/trebleclef.in.jpg",
    categories: '["services", "creative"]',
    projectLink: "https://trebleclef.in",
  },
  {
    id: 17,
    title: "Ashok & Co. (Pvt.) Ltd.",
    image: "/img/portfolio-img/myhygeia.com.jpg",
    categories: '["services", "ecom"]',
    projectLink: "https://myhygeia.com",
  },
  {
    id: 18,
    title: "OS Consulting Pvt. Ltd.",
    image: "/img/portfolio-img/osconsultingprivatelimited.in.jpg",
    categories: '["services"]',
    projectLink: "https://osconsultingprivatelimited.in",
  },
  {
    id: 19,
    title: "Novia Electrical",
    image: "/img/portfolio-img/noviaelectrical.in.jpg",
    categories: '["services"]',
    projectLink: "https://noviaelectrical.in",
  },
  
];

const categories = [
  { id: "all", label: "All" },
  { id: "ecom", label: "E-Commerce" },
  { id: "travel", label: "Travel & Hospitality" },
  { id: "services", label: "Professional Services" },
  { id: "creative", label: "Creative & Media" },
];

const getCategoryCount = (category) => {
  const count =
    category === "all"
      ? portfolioData.length
      : portfolioData.filter((item) =>
          JSON.parse(item.categories).includes(category)
        ).length;
  return count.toString().padStart(2, "0"); // Adds leading zero if count < 10
};

const PortfolioTwo = () => {
  return (
    <section className="works explore-area portfolio-filter pt-0">
      <div className="container p-0">
        <div className="row justify-content-center text-center">
          <div className="col-12">
            <div
              className="btn-group filter-menu"
              role="group"
              aria-label="Basic radio toggle button group"
            >
              {categories.map(({ id, label }) => (
                <div key={id} className="input-item d-flex">
                  <div className="content">
                    <input
                      type="radio"
                      className="btn-check filter-btn"
                      name="shuffle-filter"
                      id={id}
                      defaultValue={id}
                      defaultChecked={id === "all"}
                    />
                    <label className="btn" htmlFor={id}>
                      {label}
                    </label>
                  </div>
                  <span className="count">{getCategoryCount(id)}</span>
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className="row filter-items items inner">
          {/* Dynamically rendering Portfolio Items */}
          {portfolioData.map((item) => (
            <div
              key={item.id}
              className="col-12 col-lg-4 item filter-item"
              data-groups={item.categories}
            >
              {/* Portfolio Item */}
              <div className="card portfolio-item layout-2 scale has-shadow">
                <div className="image-holder">
                  {/* Card Thumb */}
                  <a className="card-thumb" href={item.projectLink} target="_blank" rel="noopener noreferrer">
                    <img src={item.image} alt={item.title} />
                  </a>
                </div>
                {/* Card content */}
                <div className="card-content p-2">
                  <div className="heading">
                    <h4 className="title mt-2 mt-md-3 mb-3">{item.title}</h4>
                    <div className="show-project">
                      <div className="card-terms">
                        {typeof item.categories === "string"
                          ? JSON.parse(item.categories).map(
                              (category, index) => (
                                <a
                                  key={index}
                                  className="terms badge"
                                  href="/portfolio"
                                >
                                  {category.replace("-", " ")}
                                </a>
                              )
                            )
                          : null}
                      </div>
                      <div className="project-link">
                        <a
                          href={item.projectLink}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          Show Project 
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default PortfolioTwo;
